var SCM = SCM || {};
SCM.JournalCitationFilter = (function ($) {

    var journalParam = 'f_JournalDisplayName',
        yearParam = $('#journalCitationDateParam').length ? $('#journalCitationDateParam').val() : 'rg_IssuePublicationDate',
        volumeParam = 'f_Volume',
        issueNoParam = 'f_IssueNo',
        startPageParam = 'f_StartPage';

    var journalQueryStringValue = null,
        yearQueryStringValue = null,
        volumeQueryStringValue = null,
        issueNoQueryStringValue = null,
        startPageQueryStringValue = null;

    var journal = null,
        year = null,
        volume = null,
        issueNo = null,
        startPage = null,

        yearPattern = null,
        volumePattern = null,
        issuePattern = null,
        startPagePattern = null,

        toggleButton = null,
        widgetWrap = null;

    var placeholderTextJournal = null,
        placeholderTextYear = null,
        placeholderTextVolume = null,
        placeholderTextIssueNo = null,
        placeholderTextStartPage = null,
        validationMessageJournal = null,
        validationMessageYear = null,
        validationMessageVolume = null,
        validationMessageIssueNo = null,
        validationMessageStartPage = null;

    function init() {
        if (!journalCitationFilterLoaded()) {
            return;
        }
        _initializeQueryStringValues();
        _initializeElements();
        _initializeHiddenFields();
        if (_fillInFieldsBasedOnQueryStringValues() === true) {
            _openWidget();
        }
    }

    // Rebuild the query string without the old journal citation filter parameters,
    // which we will rebuild and then insert.  
    //
    // Caveats:
    // * We replace the page number with 'page=1'.
    // * We do NOT drop noDateTypes and dateFilterType but they don't survive the ISearchParameters round trip anyway.
    //
    // Note: based on client.queryBuilder.js from OUP.Web
    function _resetCitationFilterParameters(lastSearchQueryString /* the old search query string */) {
        // original ones
        var oldQueryParams = lastSearchQueryString.split('&');

        // strip out some params 
        var paramsToRemove = [
            // journal citation parameters we plan to rebuild
            journalParam,
            yearParam,
            volumeParam,
            issueNoParam,
            startPageParam,
            // also reset
            'page'
        ];
        var queryParams = oldQueryParams.filter(function (el) {
            var paramType = el.split('=')[0];
            return paramsToRemove.indexOf(paramType) < 0;  // keep if not found in list
        });

        // page = 1
        queryParams.push('page=1');

        // build joined query string
        var queryString = queryParams.join('&').trim();
        return queryString;
    }

    function journalCitationFilterLoaded() {
        var loadedFlag = document.getElementById('hfJournalCitationFilterLoaded');
        return !!(loadedFlag && loadedFlag.value);
    }

    function _initializeQueryStringValues() {
        journalQueryStringValue = getQueryStringValue(location.search, journalParam),
        yearQueryStringValue = getQueryStringValue(location.search, yearParam),
        volumeQueryStringValue = getQueryStringValue(location.search, volumeParam),
        issueNoQueryStringValue = getQueryStringValue(location.search, issueNoParam),
        startPageQueryStringValue = getQueryStringValue(location.search, startPageParam);
    }

    function _initializeElements() {
        journal = document.getElementById('SelectedJournal');
        year = document.getElementById('Citation_IssuePublicationDate'),
        volume = document.getElementById('Citation_Volume'),
        issueNo = document.getElementById('Citation_IssueNo'),
        startPage = document.getElementById('Citation_StartPage');

        yearPattern = isDefined(year) ? year.getAttribute('pattern') : null;
        volumePattern = isDefined(volume) ? volume.getAttribute('pattern') : null;
        issuePattern = isDefined(issueNo) ? issueNo.getAttribute('pattern') : null;
        startPagePattern = isDefined(startPage) ? startPage.getAttribute('pattern') : null;

        toggleButton = document.getElementsByClassName('js-journal-citation-filter-toggle')[0];
        widgetWrap = document.getElementsByClassName('journal-citation-filter-input-wrap')[0];
    }

    function _initializeHiddenFields() {
        placeholderTextJournal = _getValueOrDefaultByElementId('Config_PlaceholderTextJournal');
        placeholderTextYear = _getValueOrDefaultByElementId('Config_PlaceholderTextYear');
        placeholderTextVolume = _getValueOrDefaultByElementId('Config_PlaceholderTextVolume');
        placeholderTextIssueNo = _getValueOrDefaultByElementId('Config_PlaceholderTextIssueNo');
        placeholderTextStartPage = _getValueOrDefaultByElementId('Config_PlaceholderTextStartPage');
        validationMessageJournal = _getValueOrDefaultByElementId('Config_ValidationMessageJournal');
        validationMessageYear = _getValueOrDefaultByElementId('Config_ValidationMessageYear');
        validationMessageVolume = _getValueOrDefaultByElementId('Config_ValidationMessageVolume');
        validationMessageIssueNo = _getValueOrDefaultByElementId('Config_ValidationMessageIssueNo');
        validationMessageStartPage = _getValueOrDefaultByElementId('Config_ValidationMessageStartPage');
    }

    function _getValueOrDefaultByElementId(elementId, defaultValue) {
        defaultValue = defaultValue || '';
        return (document.getElementById(elementId) || {}).value || defaultValue;
    }

    function _fillInFieldsBasedOnQueryStringValues() /* -> bool */ {
        if (isDefined(journalQueryStringValue) && isDefined(journal) ||
            isDefined(yearQueryStringValue) && isDefined(year) ||
            isDefined(volumeQueryStringValue) && isDefined(volume) ||
            isDefined(issueNoQueryStringValue) && isDefined(issueNo) ||
            isDefined(startPageQueryStringValue) && isDefined(startPage)) {
                year.value = _getYearFrom(yearQueryStringValue);
                volume.value = volumeQueryStringValue;
                issueNo.value = issueNoQueryStringValue;
                startPage.value = startPageQueryStringValue;
                return true;
            }
        return false;
    }

    function _getYearFrom(dateString) {
        if (!isDefined(dateString)) return '';

        var dates = decodeURIComponent(dateString).split('TO').map(function (x) { return x.replace('+', ''); });
        dateString = dates.length > 0 ? dates[0] : dateString;

        var date = new Date(dateString);
        return date.getUTCFullYear();
    }

    // Build the parts of the search query that arise from the updated options in the journal citation filter.
    // NOTE: we will add on other sources of filters separately.
    function _buildJournalFilters() {
        var journalValue = isDefined(journal) && journal.options.length > 0 && isDefined(journal.options[journal.selectedIndex])
            ? journal.options[journal.selectedIndex].textContent
            : '',
            yearValue = isDefined(year) ? year.value : '',
            volumeValue = isDefined(volume) ? volume.value : '',
            issueNoValue = isDefined(issueNo) ? issueNo.value : '',
            startPageValue = isDefined(startPage) ? startPage.value : '';

        var citationData = {};
        var validationMessage = '';

        // JOURNAL
        if (journalValue === placeholderTextJournal && journalValue !== '') {
            validationMessage = validationMessageJournal + '\n';
        } else if (journalValue !== '') {
            citationData[journalParam] = $.trim(journalValue);
        }

        // YEAR
        if (yearValue !== placeholderTextYear && yearValue !== '') {
            var yearRegex = new RegExp(yearPattern);
            if (isNaN(yearValue) || !yearRegex.test(yearValue)) {
                validationMessage += validationMessageYear + '\n';
            } else {
                //var rangequery = yearValue + '-01-01T00:00:00.000Z TO ' + yearValue + '-12-31T23:59:59.000Z';
                //Instead of using the ISO format, just using the MM/DD/YYYY format
                var rangequery = '01/01/' + yearValue + ' TO ' + '12/31/' + yearValue;
                citationData[yearParam] = rangequery;
            }
        }

        // VOLUME
        if (volumeValue !== placeholderTextVolume && volumeValue !== '') {
            var volumeRegex = new RegExp(volumePattern);
            if (volumeRegex.test(volumeValue)) {
                citationData[volumeParam] = volumeValue;
            } else {
                validationMessage += validationMessageVolume + '\n';
            }
        }

        // ISSUE
        if (issueNoValue !== placeholderTextIssueNo && issueNoValue !== '') {
            var issueRegex = new RegExp(issuePattern);
            if (issueRegex.test(issueNoValue)) {
                citationData[issueNoParam] = issueNoValue;
            } else {
                validationMessage += validationMessageIssueNo + '\n';
            }
        }

        // START PAGE
        if (startPageValue !== placeholderTextStartPage && startPageValue !== '') {
            var startPageRegex = new RegExp(startPagePattern);
            if (startPageRegex.test(startPageValue)) {
                citationData[startPageParam] = startPageValue;
            } else {
                validationMessage += validationMessageStartPage + '\n';
            }
        }

        if (validationMessage.length > 0) {
            //validation failed!
            alert(validationMessage);
            return false;
        }

        return citationData;
    }

    // Build the query string and run the search, which will cause a page update.
    //
    // @lastSearchQueryString
    //     The search query parameters BEFORE applying changes in the journal citation filter(e.g., 'page=2&...'
    //     This is not always the same as the browser URL.  Instead, it's typically in a response from the server.
    // @currentUrlQueryString (optional)
    //     The query parameters on the browser URL.  We use this to capture some obscure data filter information.    
    //
    function applyFilter(lastSearchQueryString, currentUrlQueryString) {
        // build data set in the journal filter panel
        var citationData = _buildJournalFilters();
        if (!citationData) {
            // validation failed
            return false;
        }
        var journalCitationQS = jsonToQueryString(citationData);

        // Get current search query string, minus the journal citation filters, and with the page number set to one.
        var otherFiltersQS = _resetCitationFilterParameters(lastSearchQueryString);

        // As an edge case, capture the dateFilterType and noDateTypes filters.
        // I'm not entirely sure what they do, but after speaking to the author for the date filter,
        // it sounds best to save them when present.  NOTE: They're used by OUP.  - JG 2020
        // 
        // NOTE: We have to check the query parameters because they don't survive
        var magicDateQS = '';
        if (currentUrlQueryString) {
            magicDateQS = currentUrlQueryString.split('&').filter(function (el) {
                var paramType = el.split('=')[0];
                return paramType === 'dateFilterType' || paramType === 'noDateTypes';
            }).join('&').trim();
        }

        // combine queries
        var queryString = journalCitationQS;
        if (otherFiltersQS) {
            queryString += '&' + otherFiltersQS;
        }
        if (magicDateQS) {
            queryString += '&' + magicDateQS;
        }
        var searchResultsParams = { queryString:  queryString };

        // set basesite value in searchresults defaults
        var baseSiteURL = $('#hfSiteURL');
        if (typeof baseSiteURL !== 'undefined' && baseSiteURL.val() !== '') {
            SCM.SearchResults.defaults.baseSiteUrl = baseSiteURL.val();
        }

        SCM.SearchResults.doSolrSearch(searchResultsParams);
        return false;
    }

    function toggleWidget() {
        if (widgetWrap.className.indexOf('collapsed') !== -1) {
            _openWidget();
        } else {
            _closeWidget();
        }
    }

    function _openWidget() {
        widgetWrap.classList.remove('collapsed');
        if (toggleButton.className.indexOf('icon-general-arrow-filled-right') !== -1) {
            toggleButton.classList.remove('icon-general-arrow-filled-right');
            toggleButton.classList.add('icon-general-arrow-filled-down');
        }
    }

    function _closeWidget() {
        widgetWrap.classList.add('collapsed');
        if (toggleButton.className.indexOf('icon-general-arrow-filled-down') !== -1) {
            toggleButton.classList.remove('icon-general-arrow-filled-down');
            toggleButton.classList.add('icon-general-arrow-filled-right');
        }
    }

    return {
        init: init,
        applyFilter: applyFilter,
        toggleWidget: toggleWidget,
        journalCitationFilterLoaded: journalCitationFilterLoaded
    };

})(jQuery);

$(document).ready(function () {
    if (!SCM.JournalCitationFilter.journalCitationFilterLoaded()) {
        return;
    }

    SCM.JournalCitationFilter.init();

    function callApplyFilter() {
        // get query string from last server request and from current URL in browser
        var lastSearchQueryString = $('.js-journal-citation-filter-update').data('searchUri');
        var currentUrlQueryString = window.location.search;
        if (currentUrlQueryString.length) {
            // drop ? prefix
            currentUrlQueryString = currentUrlQueryString.substring(1);
        }

        // run query
        SCM.JournalCitationFilter.applyFilter(lastSearchQueryString, currentUrlQueryString);
    }

    //Citation Search Click
    $(document).on('click', '.js-journal-citation-filter-update', function () {
        $(this).addClass('fade');
        grayOutSidebar();
        callApplyFilter(); // collect data and run the new search
    });

    //Enter key
    $(document).on('keyup', '.js-advanced-citation-filter-field', function (e) {
        if (e.keyCode === 13) {
            e.preventDefault();
            $('.js-journal-citation-filter-update').addClass('fade');
            grayOutSidebar();
            callApplyFilter(); // collect data and run the new search
        }
    });

    function grayOutSidebar() {
        $(document).ajaxStart(function() {
            $('.info-inner-cover').removeClass('uncovered');
            $('.info-inner-cover').addClass('covered');
        });
        $(document).ajaxComplete(function() {
            $('.info-inner-cover').removeClass('covered');
            $('.info-inner-cover').addClass('uncovered');
        });
    }

    $(document).on('click', '.js-journal-citation-filter-toggle', function () {
        SCM.JournalCitationFilter.toggleWidget();
    });

    // when user changes value of an input
    $(document).on('keyup change', '.js-advanced-citation-filter-field', function () {
        $('.js-journal-citation-filter-update').removeClass('fade');
    });
});

//Retrieves the values of a key from dataUrl
function getQueryStringValue(dataUrl, key) {
    var keyValue;
    var startText = key + '=';
    var endText = '&';
    var qPos = dataUrl.indexOf(startText);

    if (qPos === -1) {
        //key doesn't exist.
        return null;
    }
    else {
        qPos = qPos + startText.length;
    }

    if (dataUrl.indexOf('&', qPos) >= 0) {
        var ampPos = dataUrl.indexOf(endText, qPos);
        keyValue = dataUrl.substring(qPos, ampPos);
    }
    else {
        //data-url will be just like q=obesity
        keyValue = dataUrl.substring(qPos);
    }

    return keyValue;
}
function isDefined(element) {
    return typeof element !== 'undefined' && element !== undefined && element != null && element !== '';
}
function jsonToQueryString(json) {
    return Object.keys(json)
        .filter(function (key) { return isDefined(key); })
        .map(function (key) { return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]); })
        .join('&');
}